/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const PROJECT_SOURCE_TYPES = {"PROJECT":"Project","SOURCELESS_PROJECT":"SourcelessProject","BYOA_PROJECT":"ByoaProject"};
